import React from "react";

import styles from "../../../../styles/add-product.module.scss";

import SetPizzaSizesStepChild from "./setSizesFolder/SetPizzaSizesStepChild";
import SetDrinkSizesStepChild from "./setSizesFolder/SetDrinkSizesStepChild";
import SetOtherSizesStepChild from "./setSizesFolder/SetOtherSizesStepChild";

export default class SetSizesStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryType: props.categoryType || 'pizza',
      category: props.category || {},
      product: props.product || {},
      onChange: props.onChange || {},
      onChangePromo: props.onChangePromo || {},
    };
  }

  render() {
    return (
      <>
        {
          this.state.categoryType === 'pizza' &&
          <SetPizzaSizesStepChild
            category={this.state.category}
            product={this.state.product}
            onChange={(value, index) => this.state.onChange(value, index)}
            onChangePromo={(sizes, index) => this.state.onChangePromo(sizes, index)}
          />
        }
        {
          this.state.categoryType === 'drink' &&
          <SetDrinkSizesStepChild
            category={this.state.category}
            product={this.state.product}
            onChange={(value, index) => this.state.onChange(value, index)}
          />
        }
        {
          this.state.categoryType === 'step' &&
          <SetOtherSizesStepChild
            category={this.state.category}
            product={this.state.product}
            onChange={(value, index) => this.state.onChange(value, index)}
            onChangePromo={(sizes, index) => this.state.onChangePromo(sizes, index)}
          />
        }
      </>
    );
  }
}
